var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ingresox"},[_c('iframe',{ref:"",staticStyle:{"border":"0px"},attrs:{"width":"100%","height":"100%","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }